import { API } from "@/lib/api";
import { APIService, FetchListRequestParams } from "@/services/api";
import {
  StoreProjectAssigneeListItem,
  ReadStoreProjectAssignee,
  StoreProjectAssigneeCreate,
  StoreProjectAssigneeCreateResponse,
  StoreProjectAssigneeUpdate,
  StoreProjectAssigneeUpdateResponse,
} from "@/types/storeProjectAssignees";

const service = new APIService<
  StoreProjectAssigneeListItem,
  StoreProjectAssigneeCreate
>(API.StoreProjectAssignees);

export const StoreProjectAssigneesService = {
  getList: (params: FetchListRequestParams<StoreProjectAssigneeListItem>) =>
    service.getList(params),
  getById: (id: string) => service.get<ReadStoreProjectAssignee>(id),
  post: (data: StoreProjectAssigneeCreate) =>
    service.post<
      StoreProjectAssigneeCreate,
      StoreProjectAssigneeCreateResponse
    >(data),
  update: (id: string, data: StoreProjectAssigneeUpdate) =>
    service.patch<
      StoreProjectAssigneeUpdate,
      StoreProjectAssigneeUpdateResponse
    >(id, data),
  delete: (id: string) => service.delete(id),
};
